import { createContext, useContext, useState, useCallback } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [aiOpen, setAiOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("register");
  const [buildHuntOpen, setBuildHuntOpen] = useState(false);
  const [dashboardHuntId, setDashboardHuntId] = useState(null);
  const [gearOpen, setGearOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [aiSeed, setAiSeed] = useState("");
  const [aiAutoSend, setAiAutoSend] = useState(false);
  const [aiContext, setAiContext] = useState(null);
  const [shareDraft, setShareDraft] = useState(null);
  const [compareStates, setCompareStates] = useState(() => {
    try { return JSON.parse(localStorage.getItem("hr_compare") || "[]"); } catch { return []; }
  });

  const persistCompare = useCallback((next) => {
    setCompareStates(next);
    try { localStorage.setItem("hr_compare", JSON.stringify(next)); } catch { /* ignore */ }
  }, []);
  const toggleCompare = useCallback((name) => {
    setCompareStates((cur) => {
      let next;
      if (cur.includes(name)) next = cur.filter((x) => x !== name);
      else if (cur.length >= 3) next = cur;
      else next = [...cur, name];
      try { localStorage.setItem("hr_compare", JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  }, []);
  const clearCompare = useCallback(() => persistCompare([]), [persistCompare]);

  const openAI = useCallback((seed = "", autoSend = false) => {
    setAiSeed(seed);
    setAiAutoSend(autoSend);
    setMenuOpen(false);
    setAiOpen(true);
  }, []);
  const openHunt = useCallback((huntId) => {
    setDashboardHuntId(huntId || null);
    setMenuOpen(false);
    setBuildHuntOpen(true);
  }, []);
  const openAuth = useCallback((mode = "register") => {
    setAuthMode(mode);
    setAuthOpen(true);
  }, []);
  const shareToFeed = useCallback((draft) => {
    setShareDraft({ ...draft, _ts: Date.now() });
    setProfileOpen(false);
    setMenuOpen(false);
    setTimeout(() => {
      const el = document.getElementById("feed");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 120);
  }, []);
  const clearShareDraft = useCallback(() => setShareDraft(null), []);

  const value = {
    aiOpen, setAiOpen, openAI, aiSeed, aiAutoSend,
    aiContext, setAiContext,
    profileOpen, setProfileOpen,
    authOpen, setAuthOpen, authMode, openAuth,
    buildHuntOpen, setBuildHuntOpen,
    gearOpen, setGearOpen,
    dashboardHuntId, setDashboardHuntId, openHunt,
    menuOpen, setMenuOpen,
    shareDraft, shareToFeed, clearShareDraft,
    compareStates, toggleCompare, clearCompare, persistCompare,
  };
  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export const useUI = () => useContext(UIContext);
